"use client";

import "./globals.css";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";
import { Toaster } from "sonner";

import Header from "@/components/layout/Header";
import { matchAccess } from "@/config/routes/matchAccess";
import { SSEProvider } from "@/contexts/SSEProvider";
import { metadata } from "@/utils/metadataConfig";

import MSWProviders from "./MSWProviders";
import { QueryProviders } from "./providers";

interface RootLayoutProps {
  children: ReactNode;
  dehydratedState?: unknown;
}

const RootLayout: React.FC<RootLayoutProps> = ({ children, dehydratedState }) => {
  const pathname = usePathname();
  const isPublicAccess = matchAccess(pathname);

  return (
    <html lang="ko">
      <head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <link
          rel="preload"
          href="/fonts/PretendardVariable.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
      </head>
      <body>
        <Toaster position="bottom-center" richColors closeButton duration={5000} />
        <MSWProviders>
          <QueryProviders dehydratedState={dehydratedState}>
            <SSEProvider>
              {!isPublicAccess.public ? (
                <>
                  <Header />
                  <div
                    id="main-scroll"
                    className="pt-(--header-h) overflow-auto min-h-screen"
                  >
                    {children}
                  </div>
                </>
              ) : (
                <div>{children}</div>
              )}
            </SSEProvider>
          </QueryProviders>
        </MSWProviders>
      </body>
    </html>
  );
};

export default RootLayout;
